<div class="modal-body content width-600">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{isNew ? getRessource('CreateHeader') : getRessource('EditHeader')}}
    </span>
		<div class="content">
			<exg-input [(ngModel)]="dataModelClone.cvName"
			           [caption]="enumSvc.getFieldCaption('CalculationVersion', 'cvName')"
                 [required]="isNew || (dataModelClone.cvName && dataModelClone.cvName.length === 0)">
			</exg-input>
			<exg-textarea [(ngModel)]="dataModelClone.cvDescription"
			              [caption]="enumSvc.getFieldCaption('CalculationVersion', 'cvDescription')">
			</exg-textarea>
      <!--Status-->
      <app-exg-select-enumeration [value]="dataModelClone.cvCalculationVersionStatus_enmIdent"
                                  listDisplay="enmText"
                                  (valueChange)="changeStateEnum($event)"
                                  [caption]="enumSvc.getFieldCaption('CalculationVersion', 'cvCalculationVersionStatus_enmIdent')"
                                  enumerationName="CalculationVersionStatus"
                                  class="span-6">
      </app-exg-select-enumeration>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="delete()" class="md-btn"
			        *ngIf="dataModelClone?.cvID && !data.hideDelete">
				{{getGlobal('Delete')}}
			</button>
			<button (click)="cancel()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="save()"
			        [class.disabled]="isDisabled"
			        class="md-btn">
				{{isNew ? getGlobal('Create') : getGlobal('Save')}}
			</button>
		</div>
	</div>
</div>
